import login from "./auth/login/loginEn.json";
import common from './common.json'

export const LocalEn = {
  ...login,
  ...common
}
